export default __webpack_public_path__ + "static/media/test1231.a8967c72.jpg";